import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Checkout from '../views/Checkout.vue'
import Menu from '../views/Menu.vue'
import AcCheckIn from '../views/Activity/AcCheckIn.vue'
import ScanQrCode from '../views/Activity/ScanQrCode.vue'
import Record from '../views/Record.vue'
import ReceiptPrint from '../views/ReceiptPrint.vue'
import i18n from '../i18n'
import CheckInRecord from '../views/Activity/CheckInRecord.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      title: i18n.t('login') + ' - ' + i18n.t('websiteName')
    }
  },
  {
    path: '/menu',
    name: 'Menu',
    component: Menu
  },
  {
    path: '/activity',
    name: 'AcCheckIn',
    component: AcCheckIn
  },
  {
    path: '/scanQrCode',
    name: 'ScanQrCode',
    component: ScanQrCode
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout
  },
  {
    path: '/record',
    name: 'Record',
    component: Record,
    meta: {
      title: i18n.t('receivePaymentInToday') + ' - ' + i18n.t('websiteName')
    }
  },
  {
    path: '/receipt-print',
    name: 'ReceiptPrint',
    component: ReceiptPrint,
    meta: {
      title: i18n.t('receivePaymentInToday') + ' - ' + i18n.t('websiteName')
    }
  },
  {
    path: '/checkInRecord',
    name: 'CheckInRecord',
    component: CheckInRecord
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  i18n
})

const DEFAULT_TITLE = i18n.t('websiteName')
router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE
  })
})

export default router
